import { api } from './client';

export const devicesApi = {
  register: (token: string, platform: 'ios', authorizationToken?: string) =>
    api.post<{ message: string }>(
      '/devices/register',
      { token, platform },
      authorizationToken
        ? { headers: { Authorization: `Bearer ${authorizationToken}` } }
        : undefined,
    ),
  unregister: (token: string, authorizationToken?: string) =>
    api.delete<{ message: string }>(
      '/devices/unregister',
      { token },
      authorizationToken
        ? { headers: { Authorization: `Bearer ${authorizationToken}` } }
        : undefined,
    ),
};
